import React from 'react';
import clsx from 'clsx';

import { useListContainerStyles } from './style';

type ListContainerProps = {
    className?: string,
    children: React.ReactNode,
    containerRef?: React.RefObject<HTMLDivElement>,
    compact?: boolean,
};

ListContainer.defaultProps = {
    className: '',
    compact: false,
    containerRef: null,
};

function ListContainer(props: ListContainerProps): React.ReactElement {
    const { className, children, containerRef, compact } = props;
    const classes = useListContainerStyles();
    const compactStyle = compact ? classes.compact : null;

    return (
        <div className={clsx(classes.container, compactStyle, className)} ref={containerRef}>
            {children}
        </div>
    );
}

export { ListContainer };
